<div class="w-full py-3 px-4">
  <!-- Header (Unchanged) -->
  <div class="md:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
      <svg
        class="size-6 cursor-pointer"
        [routerLink]="['/packaging-form']"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_848_1764"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path
            d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z"
            fill="#C19725"
          />
        </g>
      </svg>
      <img
        class="size-6 sm:size-8 lg:size-10"
        src="/assets/images/stock/ready-product.png"
        alt="user"
      />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444"
        >Add Packaging Stack</span
      >
    </div>
  </div>

  <form [formGroup]="packagingStackForm">
    <!-- Section: Major Packaging -->
    <div class="mt-4 md:mt-8">
      <h2 class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Major Packaging
      </h2>
    </div>

    <div class="w-full py-4 bg-[#FFFFF6] rounded-md mt-2">
      <div
        class="w-full px-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-11 xl:grid-cols-7 gap-x-3 gap-y-5"
      >
        <!-- Name -->
        <div class="col-span-1 lg:col-span-3 xl:col-span-2 2xl:col-span-1">
          <div class="relative">
            <input
              type="text"
              id="st_packaging_stack_name"
              formControlName="st_packaging_stack_name"
              autocomplete="off"
              (keydown)="allowOnlyLetters($event)"
              (paste)="blockInvalidPaste($event)"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" "
              [class.border-red-500]="
                packagingStackForm.get('st_packaging_stack_name')?.invalid &&
                packagingStackForm.get('st_packaging_stack_name')?.touched
              "
            />

            <label
              for="st_packaging_stack_name"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
            >
              Packaging Stack Name <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- ✅ Validation Error (NO layout change) -->
          <div
            *ngIf="
              packagingStackForm.get('st_packaging_stack_name')?.invalid &&
              packagingStackForm.get('st_packaging_stack_name')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *Packaging stack name is required
          </div>
        </div>

        <!-- Major -->
        <!-- <div class="col-span-1">
          <div class="relative">
            <select autocomplete="off" id="st_type_stack" formControlName="st_type_stack"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              (keydown.enter)="focusNext($event)">
              <option value="major" selected>Major</option>
            </select>
            <label for="st_type_stack"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Type</label>
          </div>
        </div> -->
        <!-- Major List -->
        <div class="col-span-1 lg:col-span-2 xl:col-span-1">
          <div class="relative">
            <select
              id="st_item_name"
              formControlName="st_item_name"
              (change)="onPackagingItemSelect()"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              [class.border-red-500]="
                packagingStackForm.get('st_item_name')?.invalid &&
                packagingStackForm.get('st_item_name')?.touched
              "
            >
              <option value="" disabled hidden selected>Select Name</option>
              <option *ngFor="let item of packagingList" [ngValue]="item">
                {{ item.st_item_name }}
              </option>
            </select>

            <label
              for="st_item_name"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
            >
              Major List
            </label>
          </div>

          <!-- ✅ Validation Error (NO layout change) -->
          <div
            *ngIf="
              packagingStackForm.get('st_item_name')?.invalid &&
              packagingStackForm.get('st_item_name')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *Major item is required
          </div>
        </div>

        <!-- Cost -->
        <div class="col-span-1">
          <div class="relative">
            <input
              
              type="text"
              id="st_unit_price"
              formControlName="st_unit_price"
              autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" "
              [class.border-red-500]="
                packagingStackForm.get('st_unit_price')?.invalid &&
                packagingStackForm.get('st_unit_price')?.touched
              "
            />

            <label
              for="st_unit_price"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
            >
              Cost <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- Validation Error (NO layout change) -->
          <div
            *ngIf="
              packagingStackForm.get('st_unit_price')?.invalid &&
              packagingStackForm.get('st_unit_price')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *Cost is required
          </div>
        </div>

        <!-- No of primary minor -->
        <div class="col-span-1 lg:col-span-2 xl:col-span-1">
          <div class="relative">
            <input
              type="number"
              id="st_no_of_primary_minor"
              formControlName="st_no_of_primary_minor"
              autocomplete="off"
              min="0"
              step="1"
              (keydown)="allowOnlyNumbers($event)"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm text-444 bg-white rounded-md border border-dcdcdc focus:outline-none focus:ring-0 focus:border-c19725"
              placeholder=" "
              [class.border-red-500]="
                packagingStackForm.get('st_no_of_primary_minor')?.invalid &&
                packagingStackForm.get('st_no_of_primary_minor')?.touched
              "
            />

            <label
              for="st_no_of_primary_minor"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
            >
              No of primary minor <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- ✅ Validation Error (NO layout change) -->
          <div
            *ngIf="
              packagingStackForm.get('st_no_of_primary_minor')?.invalid &&
              packagingStackForm.get('st_no_of_primary_minor')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *Number of primary minor is required
          </div>
        </div>
<!-- Major After Products -->
<!-- <div class="col-span-1 lg:col-span-2 xl:col-span-1">
  <div class="relative">
    <input type="number" id="st_major_after_products" formControlName="st_major_after_products" autocomplete="off"
      min="1" step="1" (keydown)="allowOnlyNumbers($event)" (keydown.enter)="focusNext($event)"
      class="block px-2 py-2 w-full text-sm text-444 bg-white rounded-md border border-dcdcdc focus:outline-none focus:ring-0 focus:border-c19725"
      placeholder=" " [class.border-red-500]="
        packagingStackForm.get('st_major_after_products')?.invalid &&
        packagingStackForm.get('st_major_after_products')?.touched
      " />

    <label for="st_major_after_products"
      class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
      Major After Products <span class="text-red-500">*</span>
    </label>
  </div> -->

  <!-- ✅ Validation Error -->
  <!-- <div *ngIf="
      packagingStackForm.get('st_major_after_products')?.invalid &&
      packagingStackForm.get('st_major_after_products')?.touched
    " class="text-red-500 text-xs mt-1">
    *Major after products is required
  </div>
</div> -->

        <!-- Major Cost on minor -->
        <div class="col-span-1 lg:col-span-2 xl:col-span-1">
          <div class="relative">
            <input
              readonly
              type="number"
              id="st_major_cost_on_minor"
              formControlName="st_major_cost_on_minor"
              autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" "
              [class.border-red-500]="
                packagingStackForm.get('st_major_cost_on_minor')?.invalid &&
                packagingStackForm.get('st_major_cost_on_minor')?.touched
              "
            />

            <label
              for="st_major_cost_on_minor"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
            >
              Major Cost on minor <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- ✅ Validation Error (NO layout change) -->
          <div
            *ngIf="
              packagingStackForm.get('st_major_cost_on_minor')?.invalid &&
              packagingStackForm.get('st_major_cost_on_minor')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *Major cost on minor is required
          </div>
        </div>
      </div>
    </div>

    <hr class="my-6 border-gray-300" />

    <!-- FIXED: Header and Button are now in a responsive flex row -->
    <div #minorSection class="flex items-center justify-between mt-4 md:mt-6">
      <h2 class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Minor Packaging
      </h2>
      <button
        type="button"
        (click)="addPackagingItem()"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]"
      >
        + Add minor
      </button>
    </div>

    <div class="w-full py-4 px-3 bg-[#FFFFF6] rounded-md mt-2">
      <!-- FIXED: Form Array container is now a responsive flex-wrap row -->
      <div
        formArrayName="st_minor_packaging_items"
        class="flex flex-wrap gap-4"
      >
        <div
          *ngIf="packagingItems.controls.length === 0"
          class="w-full text-center py-4 px-3 bg-gray-50 rounded-md"
        >
          <p class="text-sm text-gray-500">
            No minor packaging items have been added.
          </p>
        </div>
        <!-- Each added item is a flex item that can grow and wrap -->
        <div
          *ngFor="let item of packagingItems.controls; let i = index"
          [formGroupName]="i"
          class="flex-grow grid grid-cols-1 md:grid-cols-2 gap-4 min-w-full md:min-w-[400px]"
        >
          <!-- Minor List -->
          <div class="relative">
            <select
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              formControlName="st_item_name"
              (change)="onPackagingItemSelectFromArray(i)"
              placeholder=" "
            >
              <option value="" disabled hidden>Select Name</option>
              <option
                *ngFor="let pItem of minorPackagingList"
                [ngValue]="pItem"
              >
                {{ pItem.st_item_name }}
              </option>
            </select>
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
              >Minor List (Item #{{ i + 1 }})
              <span class="text-red-500">*</span></label
            >
          </div>
          <!-- Cost -->
          <div class="relative">
            <input
              type="text"
              formControlName="st_unit_price"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" "
            />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
              >Cost</label
            >
          </div>
          <!-- Validation Error (NO layout change) -->
          <div
            *ngIf="
              i === 0 &&
              packagingItems.at(0).get('st_item_name')?.invalid &&
              packagingItems.at(0).get('st_item_name')?.touched
            "
            class="text-red-500 text-xs mt-1"
          >
            *At least one minor item is required
          </div>
        </div>
      </div>

      <div class="w-full px-3 grid justify-center mt-6" *ngIf="finalValueButto">
        <div class="col-span-2 sm:col-span-1 w-full max-w-xs">
          <div class="relative">
            <input
              type="number"
              id="st_final_valuation"
              formControlName="st_final_valuation"
              autocomplete="off"
              readonly
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#F2F2F2] rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 peer"
              placeholder=" "
            />
            <label
              for="st_final_valuation"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-[#F2F2F2] px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
              >Final Value</label
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex items-center justify-center space-x-1.5 md:space-x-4 mt-4 md:mt-8"
    >
      <button
        type="button"
        (click)="onClear()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center"
      >
        Clear
      </button>
      <button
        type="button"
        *ngIf="submitbutton"
        (click)="onSubmit()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center"
      >
        Submit
      </button>
      <button
        type="button"
        *ngIf="updatebutton"
        (click)="editpackage()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center"
      >
        Update
      </button>
    </div>
  </form>
</div>

<!-- Packaging Stack List (Unchanged) -->
<div class="w-full py-3 px-4 mt-6">
  <p class="font-semibold text-sm sm:text-base lg:text-xl text-444 mb-4">
    Packaging Stack List
  </p>
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
    <table
      class="w-full table bg-white border border-[#D9D9D9] overflow-hidden"
    >
      <thead
        class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs"
      >
        <tr>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            No.
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Packaging Stack Name
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Major Item Name
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Major Cost
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            No. of Primary Minor
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Major Cost on Minor
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            More Minor Packaging Items
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Final Valuation
          </th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-xs">
        <tr *ngIf="!packagingDataList || packagingDataList.length === 0">
          <td colspan="8" class="text-center p-6 text-gray-500">
            No packaging stacks have been added.
          </td>
        </tr>
        <tr
          *ngFor="let item of packagingDataList; let i = index"
          class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]"
        >
          <td class="p-3 text-center">{{ i + 1 }}</td>
          <td class="p-3">{{ item.st_packaging_stack_name || "-" }}</td>
          <td class="p-3">{{ item.st_item_name || "-" }}</td>
          <td class="p-3">{{ item.st_unit_price || "-" }}</td>
          <td class="p-3">{{ item.st_no_of_primary_minor || "-" }}</td>
          <td class="p-3">{{ item.st_major_cost_on_minor || "-" }}</td>
          <td class="p-3">
            <table
              class="w-full border text-[10px]"
              *ngIf="item.st_minor_packaging_items?.length > 0"
            >
              <thead class="bg-gray-100">
                <tr>
                  <th class="border px-1">Item Name</th>
                  <th class="border px-1">Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sub of item.st_minor_packaging_items">
                  <td class="border px-1">{{ sub.minor_name }}</td>
                  <td class="border px-1">{{ sub.minor_cost }}</td>
                </tr>
              </tbody>
            </table>
            <span
              *ngIf="
                !item.st_minor_packaging_items ||
                item.st_minor_packaging_items.length === 0
              "
              >-</span
            >
          </td>
          <td class="p-3">{{ item.st_final_valuation || "-" }}</td>
          <td>
            <div class="flex items-center justify-center gap-1 sm:gap-2">
              <button
                class="cursor-pointer"
                [routerLink]="['/packaging-stack-form', item.st_id]"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.7166 9.23962L8.10638 15.8499"
                    stroke="#C19725"
                    stroke-miterlimit="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <button
                class="cursor-pointer p-1"
                (click)="deletePackaging(item.st_id)"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 7.5H20"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
